import api from "./axiosInstance";

// GET all goods
export const getAllGoods = () =>
  api.get("goods/getAllGoods");

// CREATE goods
export const saveGoods = (data) =>
  api.post("goods/save", data);

// UPDATE goods
export const updateGoods = (id, data) =>
  api.put(`goods/updateById/${id}`, data);

// DELETE goods
export const deleteGoods = (id) =>
  api.delete(`goods/deleteById/${id}`);